"use client";

import Toast from "@/components/design-system/toast";
import { AppState } from "@/store/store";
import { hidePublishedVendorReviewToast } from "@/store/vendorReviewToastSlice";
import { useSelector } from "react-redux";

const TOAST_MESSAGE = "Updated Review Submitted";
const TOAST_SUB_MESSAGE = "Your review will be republished once it's done processing";

const PublishedVendorReviewToast = () => {
  const showToast = useSelector((state: AppState) => state.vendorReviewToastSlice.showToast);

  return (
    <Toast
      toastMessage={TOAST_MESSAGE}
      toastSubMessage={TOAST_SUB_MESSAGE}
      showToast={showToast}
      toastType="success"
      hideToast={hidePublishedVendorReviewToast}
      showCloseButton
      showOnMobile
      showToastTime={6000}
      toastLocation="top"
    />
  );
};

export default PublishedVendorReviewToast;
